import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import DashSideBar from "../../shared/DashSideBar";
import "./Projects.css";
import axios from "axios";
import { FileUpload } from "primereact/fileupload";
import Resizer from "react-image-file-resizer";

function Projects() {
  let emptyProject = {
    id: null,
    name: "",
    description: "",
    sortOrder: null,
    imageUrl: null,
  };

  const [projects, setProjects] = useState(null);
  const [projectDialog, setProjectDialog] = useState(false);
  const [deleteProjectDialog, setDeleteProjectDialog] = useState(false);
  const [deleteProjectsDialog, setDeleteProjectsDialog] = useState(false);
  const [project, setProject] = useState(emptyProject);
  const [selectedProjects, setSelectedProjects] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [projectsLoading, setProjectsLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);

  useEffect(() => {
    setProjectsLoading(true);
    getProjects();
    setProjectsLoading(false);
  }, []);

  const getProjects = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Projects"
      );

      if (response.data) {
        setProjects(response.data);
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error Fetching Projects",
        life: 3000,
      });
    }
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        2000, // width
        2000, // height
        "WEBP", // format (can be "JPEG", "PNG", "WEBP")
        100, // quality (0-100)
        0, // rotation (optional)
        (uri) => {
          resolve(uri);
        },
        "blob" // output type (blob or base64)
      );
    });

  const openNew = () => {
    setProject(emptyProject);
    setSubmitted(false);
    setProjectDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setProjectDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProjectDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteProjectsDialog(false);
  };

  const saveProject = async () => {
    setLoading(true);
    setSubmitted(true);

    if (project.name.trim()) {
      let _projects = [...projects];
      let _project = { ...project };

      if (project.id) {
        const index = findIndexById(project.id);

        let formData = new FormData();
        formData.append("name", _project.name);
        formData.append("description", _project.description);
        formData.append("sortOrder", parseInt(_project.sortOrder));
        if (file != null) {
          formData.append("imageUrl", file);
        }

        const response = await axios.put(
          process.env.REACT_APP_BACKEND_URL + "api/Projects/" + project.id,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        setFile(false);

        setLoading(false);

        if (response.data.success) {
          _projects[index] = _project;
          if (response.data.fileName !== "")
            _projects[index].imageUrl = response.data.fileName;

          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "project Updated",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "project Not Updated",
            life: 3000,
          });
        }
      } else {
        _project.id = createId();

        let formData = new FormData();
        formData.append("name", _project.name);
        formData.append("description", _project.description);
        formData.append("sortOrder", parseInt(_project.sortOrder));
        formData.append("imageUrl", file);

        const response = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "api/Projects",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        setLoading(false);
        setFile(null);
        if (response.data.success) {
          _projects.push(response.data.project);

          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "project Created",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "project Not Created",
            life: 3000,
          });
        }
      }

      setProjects(_projects);
      setProjectDialog(false);
      setProject(emptyProject);
    }
  };

  const editProduct = (project) => {
    setProject({ ...project });
    setProjectDialog(true);
  };

  const confirmDeleteProduct = (project) => {
    setProject(project);
    setDeleteProjectDialog(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    const response = await axios.delete(
      process.env.REACT_APP_BACKEND_URL + "api/Projects/" + project.id
    );
    setLoading(false);
    if (response.data.success) {
      let _projects = projects.filter((val) => val.id !== project.id);
      setProjects(_projects);
      setDeleteProjectDialog(false);
      setProject(emptyProject);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "project Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "project Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < projects.length; i++) {
      if (projects[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteProjectsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedProjects.map((project) => project.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/Projects/DeleteProjectsByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _projects = projects.filter((val) => !selectedProjects.includes(val));
      setProjects(_projects);
      setDeleteProjectsDialog(false);
      setSelectedProjects(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "projects Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "projects Not Deleted",
        life: 3000,
      });
    }
  };
  const onFileUpload = async (event) => {
    setLoading(true);
    const file = event.files[0];
    const resizedImage = await resizeFile(file); // Resize the image

    // Create a new File from the blob with the correct name and MIME type
    const newFile = new File([resizedImage], file.name, {
      type: resizedImage.type || "image/jpeg", // Set MIME type
    });

    setFile(newFile);

    setProject((prevProject) => ({
      ...prevProject,
      imageUrl: process.env.REACT_APP_BACKEND_URL_IMAGES + newFile.name, // Save the file name as the image path for simplicity
    }));
    setLoading(false);
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _project = { ...project };

    _project[`${name}`] = val;

    setProject(_project);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Projects</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };
  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedProjects || !selectedProjects.length}
        />
      </div>
    );
  };
  const imageBodyTemplate = (rowData) => {
    return (
      <img
        loading="lazy"
        src={process.env.REACT_APP_BACKEND_URL_IMAGES + rowData.imageUrl}
        alt={rowData.imageUrl}
        className="shadow-2 border-round"
        style={{ width: "64px" }}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Projects</h4> */}
      {/* <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label="Save"
        loading={loading}
        icon="pi pi-check"
        onClick={saveProject}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        loading={loading}
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        loading={loading}
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );
  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="projects-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              loading={projectsLoading}
              ref={dt}
              value={projects}
              selection={selectedProjects}
              onSelectionChange={(e) => setSelectedProjects(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Projects"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="name"
                header="Name"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="imageUrl"
                header="Image"
                body={imageBodyTemplate}
              ></Column>
              <Column
                field="sortOrder"
                sortable
                header="Order"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={projectDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Project Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            {project.imageUrl && (
              <div className="image-container">
                <img
                  loading="lazy"
                  src={
                    process.env.REACT_APP_BACKEND_URL_IMAGES + project.imageUrl
                  }
                  alt={project.imageUrl}
                  className="product-image block m-auto pb-3"
                />
              </div>
            )}
            <div className="field">
              <label htmlFor="name" className="font-bold mb-1">
                Name :
              </label>
              <InputText
                id="name"
                value={project.name}
                onChange={(e) => onInputChange(e, "name")}
                required
                autoFocus
                className={classNames({
                  "p-invalid": submitted && !project.name,
                })}
              />
              {submitted && !project.name && (
                <small className="p-error">Name is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="description" className="font-bold mt-3 mb-1">
                Description :
              </label>
              <InputTextarea
                id="description"
                value={project.description}
                onChange={(e) => onInputChange(e, "description")}
                required
                rows={3}
                cols={20}
              />
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={project.sortOrder}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !project.sortOrder,
                })}
              />
              {submitted && !project.sortOrder && (
                <small className="p-error">sortOrder is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="image" className="mt-3 font-bold mb-1">
                Image :
              </label>
              <FileUpload
                name="image"
                mode="basic"
                accept="image/*"
                onSelect={onFileUpload}
              />
            </div>
          </Dialog>

          <Dialog
            visible={deleteProjectDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {project && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{project.name}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={deleteProjectsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {project && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected projects?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default Projects;
